import { useEffect, useState } from 'react';
import { resetAppState } from '@/lib/reset.js';

export default function Reset() {
  const [status, setStatus] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const log = (msg) => { if (!cancelled) setStatus(prev => [...prev, msg]); };

      log('Unregistering service workers…');
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map(r => r.unregister()));
        log(`  Unregistered ${regs.length} service worker(s)`);
      } else {
        log('  No service worker support');
      }

      log('Clearing cache storage…');
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
        log(`  Deleted ${keys.length} cache(s)`);
      } else {
        log('  No cache storage support');
      }

      log('Clearing local storage…');
      localStorage.clear();
      sessionStorage.clear();
      log('  Done');

      log('Redirecting to / in 1 second…');
      setTimeout(() => {
        if (!cancelled) window.location.href = '/';
      }, 1000);
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-6">
      <div className="w-full max-w-sm space-y-4 text-center">
        <h1 className="text-lg font-semibold text-text">Resetting TRACON…</h1>
        <ul className="space-y-1 text-left text-sm text-text-muted">
          {status.map((msg, i) => (
            <li key={i} className="font-mono text-xs">{msg}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
